import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
        error: null,
        devices: [{ id: 0, name: "Local" }],
        searchDevices: { /*0:{ id: 0, name: "Local" }*/ },
        loading: false
};

const deviceLoadSuccess = (state, action) => {
    const devices = state.devices;
    
    if(action.devices.count) {
        const elements = action.devices.device.elements;
        for (let key in elements) {
            devices.push({ id: elements[key].getId(), name: elements[key].getOptions().get('label')});
        }
    }
    
    return updateObject( state, { loading: false, devices: devices } );
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.DEVICE_LOAD_START:
            return updateObject(state, { loading: true });
        case actionTypes.DEVICE_LOAD_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.DEVICE_LOAD_SUCCESS:
            return deviceLoadSuccess(state, action);
        case actionTypes.DEVICE_SET_SEARCH:
            return updateObject(state, { searchDevices: action.devices });
        default: 
            return state;
    }
}

export default reducer;
